import React from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import { MdStar } from "react-icons/md";
const tableHead = [
  "Sr.",
  "Name",
  "Contact Number",
  "Address",
  "Applied for",
  "Actions",
];

const getClassname = (status) => {
  if (status === "reachedToAlpha") {
    return "bg-success-lt";
  } else {
    return "";
  }
};

const NhmAppTable = ({ data = [], currentPage, itemsPerPage }) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/view-nhm-applicants/${id}`);
  };
  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={item?.id} className={getClassname(item?.seenStatus)}>
                <td>
                  {Index}
                  {item?.addedInLead && <MdStar color="green" />}
                </td>
                <td>{item?.Name || "N/A"}</td>
                <td>{item?.Mobile || "N/A"}</td>
                <td>
                  {item?.Village || "N/A"}, {item?.Taluka || "N/A"},{" "}
                  {item?.District || "N/A"}.
                </td>
                <td>{item?.Structure || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item?.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default NhmAppTable;
